<template>
  <div class="box">
    <div class="row remote_video_container">
      <div v-show="isUserLoaded" class="local-actions">
        <div
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="'settings_tooltip' | i18n"
          :class="`button-dissable ${showConfig ? 'red-btn' : ''}`"
          @click="showConfig = !showConfig"
        >
          <img :src="cogIcon" />
        </div>
        <div v-show="showConfig" class="config-box">
          <div class="config-wrapper">
            <div class="config-wrapper-block">
              <span>{{ 'microphone' | i18n }}:</span>
              <select id="audio-devices" class="camera-select"></select>
            </div>
            <div class="config-wrapper-block">
              <span>{{ 'camera' | i18n }}:</span>
              <select id="video-devices" class="camera-select"></select>
            </div>
          </div>
        </div>
        <div
          id="mute"
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="`${isMicro ? 'mic_off_tooltip' : 'mic_on_tooltip'}` | i18n"
          :class="`mute button-dissable ${isMicro ? '' : 'button-dissable-cross'}`"
        >
          <img :src="microphoneIcon" />
        </div>
        <div
          id="stopVideo"
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="`${isVideo ? 'camera_off_tooltip' : 'camera_on_tooltip'}` | i18n"
          :class="`stopVideo button-dissable ${isVideo ? '' : 'button-dissable-cross'}`"
        >
          <img :src="cameraIcon" />
        </div>
        <div
          id="shareScreen"
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="`${isScreenSharing ? 'close_share_tooltip' : 'open_share_tooltip'}` | i18n"
          :class="`shareScreen button-dissable ${isScreenSharing ? 'stopScreenSharing' : ''}`"
        >
          <img :src="shareScreenIcon" />
        </div>
        <div
          v-if="id"
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="`${colomns.project ? 'close_project_tooltip' : 'open_project_tooltip'}` | i18n"
          :class="`button-dissable ${colomns.project ? 'red-btn' : ''}`"
          @click="() => triggerWindow('project', 6)"
        >
          <img :src="templateIcon" />
        </div>
        <!-- <div :class="`button-dissable ${colomns.template ? 'red-btn' : ''}`" @click="() => triggerWindow('template')">
          <img :src="checkboxesIcon" />
        </div> -->
        <div
          v-b-tooltip.hover="{ variant: 'dark' }"
          :title="`${colomns.chat ? 'close_chat_tooltip' : 'open_chat_tooltip'}` | i18n"
          :class="`button-dissable ${colomns.chat ? 'red-btn' : ''}`"
          @click="
            () => {
              setMessageCount(0);
              triggerWindow('chat', 3);
            }
          "
        >
          <img :src="chatIcon" />
          <div class="message-count" v-if="!colomns.chat && messageCount">
            {{ messageCount }}
          </div>
        </div>
        <div
          id="shareIcon"
          v-b-tooltip.hover="{ variant: 'dark' }"
          v-b-modal.share-project-modal
          :title="'share_call_tooltip' | i18n"
          :class="`shareIcon button-dissable`"
        >
          <img :src="shareIcon" />
        </div>
        <div v-b-tooltip.hover="{ variant: 'dark' }" :title="'end_call_tooltip' | i18n" @click="navigateBack" :class="`endCall button-dissable`">
          <img :src="phoneIcon" />
        </div>
      </div>
      <div class="loadingBlock">
        <span v-if="loading"> Loading...</span>
        <span v-else-if="!loading && roomName"> Connected to room</span>
      </div>
      <div class="remoteTrackWrapper">
        <div id="remoteTrack" ref="screenshotRef" />
        <div class="trackListWrapper">
          <div id="trackList"></div>
        </div>
        <div class="remove-pin-box">
          <div class="remove-pin" v-if="isPinedVideo" @click="isPinedVideo = false">{{ 'Remove pin' | i18n }}</div>
          <div class="remove-pin" v-else @click="pinMainCamera">{{ 'Pin' | i18n }}</div>
          <div class="remove-pin" v-if="isPinedVideo" @click="takeScreenshot">
            {{ 'Screenshot' | i18n }}
          </div>
          <EditScreenshot id="edit-screenshot-modal" :title="'Edit screenshot' | i18n" :screenshot="screenshot" :hash="hash" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Twilio, { LocalVideoTrack } from 'twilio-video';
import html2canvas from 'html2canvas';
import microphoneIcon from '../../../../../../assets/icons/microphone.svg';
import cameraIcon from '../../../../../../assets/icons/camera.svg';
import phoneIcon from '../../../../../../assets/icons/phone.svg';
import shareIcon from '../../../../../../assets/icons/share.svg';
import chatIcon from '../../../../../../assets/icons/chat.svg';
import checkboxesIcon from '../../../../../../assets/icons/checkboxes.svg';
import templateIcon from '../../../../../../assets/icons/template.svg';
import cogIcon from '../../../../../../assets/icons/cog.svg';
import shareScreenIcon from '../../../../../../assets/icons/share-screen.svg';
import { NotificationMixin, AuthMixin, FirebaseMixinOne } from '../../../../../../mixins';
import api from '../../../../../api';
import EditScreenshot from './modals/edit-screenshot';

export default {
  name: 'Video',
  components: { EditScreenshot },
  mixins: [NotificationMixin, AuthMixin, FirebaseMixinOne],
  props: {
    hash: {
      type: String,
      default: () => '',
    },
    meetingHash: {
      type: String,
      default: () => '',
    },
    id: {
      type: String,
      default: () => '',
    },
    colomns: {
      type: Object,
      default: () => {},
    },
    setActiveRoom: {
      type: Function,
      default: () => {},
    },
    leaveRoomIfJoined: {
      type: Function,
      default: () => {},
    },
    triggerWindow: {
      type: Function,
      default: () => {},
    },
    setMessageCount: {
      type: Function,
      default: () => {},
    },
    messageCount: {
      type: Number,
      default: () => {},
    },
  },
  data() {
    return {
      cogIcon: cogIcon,
      microphoneIcon: microphoneIcon,
      cameraIcon: cameraIcon,
      shareScreenIcon: shareScreenIcon,
      phoneIcon: phoneIcon,
      shareIcon: shareIcon,
      chatIcon: chatIcon,
      checkboxesIcon: checkboxesIcon,
      templateIcon: templateIcon,
      loading: false,
      data: {},
      remoteTrack: '',
      previewTracks: '',
      identity: '',
      roomName: null,
      isVideo: true,
      isScreenSharing: false,
      isMicro: true,
      isUserLoaded: false,
      tracks: {},
      isPinedVideo: false,
      showConfig: false,
      screenshot: null,
    };
  },
  created() {
    this.createChat(this.hash || this.meetingHash);
  },
  methods: {
    async takeScreenshot() {
      const currentDocument = this.$refs.screenshotRef;
      const video = currentDocument.getElementsByTagName('video')[0];
      const canvas = await html2canvas(video, { allowTaint: true });
      const canvasImg = canvas.toDataURL('image/jpg');
      this.screenshot = canvasImg;
      this.$root.$emit('bv::show::modal', 'edit-screenshot-modal');
    },
    pinCamera(id) {
      this.changeDominantSpeaker(id, true);
      this.isPinedVideo = true;
    },
    pinMainCamera() {
      const currentDocument = this.$refs.screenshotRef;
      const dominantList = currentDocument.getElementsByClassName('dominant');
      const id = [...dominantList][0].id;
      this.pinCamera(id);
    },
    navigateBack() {
      this.leaveRoomIfJoined();
      this.$router.go(-1);
    },
    async getAccessToken(room_name) {
      try {
        return api.projectMilestones.token({ id: room_name, projectId: this.$route.params.id, isPersonalMeetingRoom: Boolean(this.meetingHash) });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    changeDominantSpeaker(id, isClick) {
      if (!isClick && this.isPinedVideo) {
        return;
      }
      const el = document.getElementById(id);

      if (el) {
        const dominants = document.getElementsByClassName('dominant');
        dominants.forEach((i) => {
          i.className = 'video-box';
          const trackList = document.getElementById('trackList');
          trackList.appendChild(i);
        });
        el.className = 'dominant video-box';
        const remoteTrack = document.getElementById('remoteTrack');
        remoteTrack.appendChild(el);
      }
    },
    participantConnected(participant) {
      console.log('Participant "%s" connected', participant.identity, participant.tracks);

      const dExist = document.getElementById(participant.sid);
      const d = dExist ? dExist : document.createElement('div');
      d.className = `video-box`;
      d.id = participant.sid;

      const dName = document.createElement('div');
      dName.innerHTML = participant.identity;
      dName.className = 'video-name';
      d.appendChild(dName);

      const dClickBox = document.createElement('div');
      dClickBox.onclick = () => this.pinCamera(participant.sid);
      dClickBox.className = 'click-box';
      d.appendChild(dClickBox);

      const container = document.getElementById('trackList');
      container.appendChild(d);

      participant.on('trackSubscribed', (track) => {
        if (track.name.indexOf('screenShare') > 0) {
          const box = document.querySelectorAll(`#${participant.sid} .video-element`);
          if (box && box.length) {
            box.forEach((b) => {
              b.style.display = 'none';
            });
          }
          this.trackSubscribed(track, participant);
        } else {
          setTimeout(() => {
            this.trackSubscribed(track, participant);
          }, 1000);
        }
      });
      participant.on('trackUnsubscribed', (track) => {
        if (track.name.indexOf('screenShare') > 0) {
          this.trackUnsubscribed(track);
          const box = document.querySelectorAll(`#${participant.sid} .video-element`);
          if (box && box.length) {
            box.forEach((b) => {
              b.style.display = 'block';
            });
          }
        } else {
          this.trackUnsubscribed(track);
        }
      });
    },
    trackSubscribed(track, participant, dominantInternal = false) {
      let elemet;
      let trackEl = track.attach();
      const dExist = document.getElementById(participant.sid);
      let dominant = dominantInternal;
      if (dExist && dExist.className.search('dominant') >= 0) {
        dominant = true;
      }
      if (dominant) {
        const dominants = document.getElementsByClassName('dominant');
        dominants.forEach((i) => {
          i.className = 'video-box';
          const trackList = document.getElementById('trackList');
          trackList.appendChild(i);
        });
      }
      if (track.kind === 'video' || track.kind === 'audio') {
        const d = dExist ? dExist : document.createElement('div');
        d.className = `${dominant ? 'dominant' : ''} video-box`;
        d.id = participant.sid;
        trackEl.className = 'video-element';
        d.appendChild(trackEl);
        elemet = d;
      } else {
        elemet = trackEl;
      }
      if (dominant) {
        const container = document.getElementById('remoteTrack');
        container.appendChild(elemet);
      } else {
        const container = document.getElementById('trackList');
        container.appendChild(elemet);
      }
    },
    trackUnsubscribed(track) {
      track.detach().forEach((element) => {
        if (element) {
          element.remove();
        }
      });
    },
    participantDisconnected(participant) {
      console.log('Participant "%s" disconnected', participant.identity);
      const el = document.getElementById(participant.sid);
      if (el) {
        el.remove();
      }
    },
    createChat(room_name) {
      this.loading = true;
      this.getAccessToken(room_name).then((data) => {
        const token = data.data;
        this.roomName = null;
        let connectOptions = {
          name: room_name,
          audio: false,
          video: false,
          dominantSpeaker: true,
        };

        this.leaveRoomIfJoined();

        document.getElementById('remoteTrack').innerHTML = '';
        Twilio.connect(token, connectOptions)
          .then((room) => {
            console.log(room, 'room');
            console.log('Successfully joined a Room: ' + room_name);
            this.setActiveRoom(room);
            this.roomName = room_name;
            this.loading = false;

            room.participants.forEach(this.participantConnected);
            room.on('participantConnected', this.participantConnected);

            room.on('participantDisconnected', this.participantDisconnected);
            room.once('disconnected', (error) => room.participants.forEach(this.participantDisconnected));

            const id = 'You';
            const dExist = document.getElementById(id);
            const d = dExist ? dExist : document.createElement('div');
            d.className = `video-box`;
            d.id = id;

            const dName = document.createElement('div');
            dName.innerHTML = id;
            dName.className = 'video-name';
            d.appendChild(dName);

            const dClickBox = document.createElement('div');
            dClickBox.onclick = () => this.pinCamera(id);
            dClickBox.className = 'click-box';
            d.appendChild(dClickBox);

            const container = document.getElementById('remoteTrack');
            container.appendChild(d);

            navigator.mediaDevices.enumerateDevices().then((mediaDevices) => {
              const select = document.getElementById('video-devices');
              select.innerHTML = '';

              const audioSelect = document.getElementById('audio-devices');
              audioSelect.innerHTML = '';

              const isVideoDevice = mediaDevices.some((i) => i.kind === 'videoinput');
              const isAudioDevice = mediaDevices.some((i) => i.kind === 'audioinput');

              let count = 0;
              let audioCount = 0;

              let cameraName = '';
              let audioName = '';

              if (isVideoDevice) {
                Twilio.createLocalVideoTrack().then((localTrack) => {
                  const localParticipant = room.localParticipant;
                  localParticipant.publishTrack(localTrack);
                  this.trackSubscribed(localTrack, { identity: id, sid: id }, true);
                  cameraName = localTrack.mediaStreamTrack.label;
                });
              }

              if (isAudioDevice) {
                Twilio.createLocalAudioTrack().then((localTrack) => {
                  const localParticipant = room.localParticipant;
                  localParticipant.publishTrack(localTrack);
                  this.trackSubscribed(localTrack, { identity: id, sid: id }, true);
                  audioName = localTrack.mediaStreamTrack.label;
                });
              }

              mediaDevices.forEach((mediaDevice) => {
                if (mediaDevice.kind === 'videoinput') {
                  count += 1;
                  const option = document.createElement('option');
                  option.value = mediaDevice.deviceId;
                  const label = mediaDevice.label || `Camera ${count}`;
                  const textNode = document.createTextNode(label);
                  if (label === cameraName) {
                    option.setAttribute('selected', 'selected');
                  }
                  option.appendChild(textNode);
                  select.appendChild(option);
                }

                if (mediaDevice.kind === 'audioinput') {
                  audioCount += 1;
                  const option = document.createElement('option');
                  option.value = mediaDevice.deviceId;
                  const label = mediaDevice.label || `Audio ${audioCount}`;
                  const textNode = document.createTextNode(`${label} ${mediaDevice.deviceId === 'default' ? ' (Default)' : ''}`);
                  if (label === audioName) {
                    option.setAttribute('selected', 'selected');
                  }
                  option.appendChild(textNode);
                  audioSelect.appendChild(option);
                }
              });

              if (count === 0) {
                select.remove();
              }

              if (audioCount === 0) {
                audioSelect.remove();
              }
            });

            this.isUserLoaded = true;

            const updateVideoDevice = (event) => {
              const select = event.target;
              const localParticipant = room.localParticipant;
              if (select.value !== '') {
                Twilio.createLocalVideoTrack({
                  deviceId: { exact: select.value },
                }).then((localVideoTrack) => {
                  const tracks = Array.from(localParticipant.videoTracks.values());

                  tracks.forEach(({ track }) => {
                    this.trackUnsubscribed(track);
                    room.localParticipant.unpublishTrack(track);
                    track.stop();
                  });
                  const myVideo = document.getElementById(id);
                  let dominant = false;
                  if (myVideo) {
                    dominant = myVideo.className.search('dominant') >= 0;
                    const video = myVideo.getElementsByTagName('video');
                    if (video && video[0]) {
                      video[0].remove();
                    }
                  }
                  localParticipant.publishTrack(localVideoTrack);
                  this.trackSubscribed(localVideoTrack, { identity: id, sid: id }, dominant);
                });
              }
            };

            const updateAudioDevice = (event) => {
              const select = event.target;
              const localParticipant = room.localParticipant;
              if (select.value !== '') {
                Twilio.createLocalAudioTrack({
                  deviceId: { exact: select.value },
                }).then((localTrack) => {
                  const tracks = Array.from(localParticipant.audioTracks.values());

                  tracks.forEach(({ track }) => {
                    this.trackUnsubscribed(track);
                    room.localParticipant.unpublishTrack(track);
                    track.stop();
                  });

                  localParticipant.publishTrack(localTrack);
                  this.trackSubscribed(localTrack, { identity: id, sid: id });
                });
              }
            };

            const videoSelect = document.getElementById('video-devices');
            videoSelect.addEventListener('change', updateVideoDevice);

            const audioSelect = document.getElementById('audio-devices');
            audioSelect.addEventListener('change', updateAudioDevice);

            room.on('dominantSpeakerChanged', (participant) => {
              console.log("Dominant Speaker Changed '" + participant);
              if (participant) {
                this.changeDominantSpeaker(participant.sid);
              } else {
                this.changeDominantSpeaker('You');
              }
            });

            const muteAudio = document.getElementById('mute');

            muteAudio.addEventListener('click', () => {
              room.localParticipant.audioTracks.forEach((track) => {
                if (this.isMicro) {
                  track.track.disable();
                } else {
                  track.track.enable();
                }
              });
              this.isMicro = !this.isMicro;
            });

            let shareScreenTrack = null;

            const shareScreen = document.getElementById('shareScreen');
            shareScreen.addEventListener('click', async () => {
              if (this.isScreenSharing) {
                this.isScreenSharing = false;
                this.trackUnsubscribed(shareScreenTrack);
                room.localParticipant.unpublishTrack(shareScreenTrack);
                const dExist = document.getElementById('YourScreen');
                if (dExist) {
                  dExist.remove();
                }
                shareScreenTrack.stop();
                shareScreenTrack = null;
              } else {
                const stream = await navigator.mediaDevices.getDisplayMedia({ video: { frameRate: 15 } });
                shareScreenTrack = new LocalVideoTrack(stream.getTracks()[0], {
                  sid: `${this.auth.id}-screenShare`,
                  name: `${this.auth.id}-screenShare`,
                });
                room.localParticipant.publishTrack(shareScreenTrack);
                this.isScreenSharing = true;
                const id = 'YourScreen';
                const dExist = document.getElementById(id);
                const d = dExist ? dExist : document.createElement('div');
                d.className = `video-box`;
                d.id = id;
                const dName = document.createElement('div');
                dName.innerHTML = 'Your screen sharing';
                dName.className = 'video-name';
                d.appendChild(dName);

                const dClickBox = document.createElement('div');
                dClickBox.onclick = () => this.pinCamera(id);
                dClickBox.className = 'click-box';
                d.appendChild(dClickBox);

                const container = document.getElementById('trackList');
                container.appendChild(d);
                this.trackSubscribed(shareScreenTrack, { identity: 'Your screen sharing', sid: id }, false);
              }
            });

            const stopVideo = document.getElementById('stopVideo');

            stopVideo.addEventListener('click', () => {
              room.localParticipant.videoTracks.forEach((track) => {
                if (track.trackName && track.trackName.indexOf('screenShare') > 0) {
                  return;
                }
                const el = document.querySelector('#You video');
                if (this.isVideo) {
                  track.track.disable();
                  if (el) {
                    el.style.display = 'none';
                  }
                } else {
                  track.track.enable();
                  if (el) {
                    el.style.display = 'block';
                  }
                }
              });
              this.isVideo = !this.isVideo;
            });
          })
          .catch((e) => console.log(e, 'Twillio connection error'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#trackList::-webkit-scrollbar {
  width: 0px !important; /* Remove scrollbar space */
  height: 0px !important; /* Remove scrollbar space */
  background: transparent !important; /* Optional: just make scrollbar invisible */
}
*::-webkit-scrollbar {
  width: 0px !important; /* Remove scrollbar space */
  height: 0px !important; /* Remove scrollbar space */
  background: transparent !important; /* Optional: just make scrollbar invisible */
}
</style>
<style lang="scss">
.remote_video_container {
  left: 0;
  margin: 0;
  position: relative;
  height: 100vh;
}
.remoteTrackWrapper {
  right: 0px;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

#remoteTrack {
  right: 0px;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

#trackList {
  width: fit-content;
  padding-left: 30px;
  padding-top: 30px;
  display: flex;
}

.trackListWrapper {
  width: 100%;
  overflow-x: scroll;
}

#trackList > div {
  margin-right: 10px;
}

.spacing {
  padding: 20px;
  width: 100%;
}
.roomTitle {
  padding: 4px;
  color: dodgerblue;
}

.dominant .click-box {
  display: none;
}

.video-box .click-box {
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  z-index: 10;
}
.video-box {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  width: 174px;
  height: 131px;
  background: white;
  /* border-radius: 20px; */
  z-index: 100;
  background: black;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.25);
}

.video-name {
  position: absolute;
  bottom: 4px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  text-align: center;
  color: black;
  font-size: 12px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  line-height: 25px;
  padding: 0 5px;
}

.camera-name {
  background: rgba(37, 93, 255, 0.7);
  color: white;
}

.dominant .video-name {
  width: auto;
  padding: 0 10px;
}

.dominant {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  z-index: 10;
}

.dominant .video-element,
.dominant iframe {
  border-radius: 0 !important;
}

.dominant video {
  width: 100%;
  height: fit-content;
  object-fit: none;
  border: none;
  /* border-radius: 19px; */
  object-fit: cover;
}

.video-element {
  width: 174px;
  height: 131px;
  border-radius: 8px;
  object-fit: cover;
}

.button-dissable {
  background: #535353;
  padding: 10px;
  border-radius: 50%;
  width: 47px;
  height: 47px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;
}

.mute img {
  width: 14px;
  height: 20px;
}
.stopVideo img {
  width: 22px;
  height: 16px;
}
.shareScreen img {
  width: 23px;
  height: 18px;
}
.endCall img {
  width: 31px;
  height: 11px;
}

.red-btn {
  background: #ff4343;
}

.endCall {
  width: 71px;
  border-radius: 40px;
  background: #ff4343;
}
.stopScreenSharing {
  background: #ff4343;
}

.local-actions {
  bottom: 75px;
  width: 100%;
  justify-content: center;
  position: absolute;
  display: flex;
  z-index: 999;
  flex-wrap: wrap;
}

.button-dissable-cross img {
  opacity: 0.2;
}

.cross-icon {
  position: absolute;
  height: 35px;
  width: 2px;
  background: black;
  transform: rotate(45deg);
}

.loadingBlock {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.remove-pin-box {
  position: absolute;
  z-index: 100;
  left: 30px;
  top: 185px;
  display: flex;
  gap: 5px;
}

.remove-pin {
  padding: 0 10px;
  color: white;
  background: #535353;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  cursor: pointer;
  font-size: 13px;
}

.camera-select {
  height: 46px;
  border-radius: 10px;
  background: #535353;
  border: 1px solid;
  color: white;
  padding: 0 10px;
  margin: 10px;
}

.config-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0px;
  width: 100%;
  justify-content: center;
  align-items: center;
  top: -130px;
}

.config-wrapper {
  display: flex;
  flex-direction: column;
  background: #535353;
  border-radius: 10px;
  color: #fff;
  .config-wrapper-block {
    display: flex;
    align-items: center;
    padding-left: 15px;
    & > span {
      width: 110px;
    }
  }
}

.message-count {
  position: absolute;
  top: -6px;
  right: -7px;
  background: #ff4343;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
</style>
